<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Message Held For Review
        </template>

        <template #content>
            <div>
                While you have a trial account, if a message is held for review, we prevent further message attempts in order to prevent spam and abuse. <br />
                <br />
                We understand that the system isn't perfect and sometimes false positives are detected. Once an admin reviews your message and its approved, you'll be able to continue sending messages on your trial. <br /><br />
                In the meantime, we'd invite you to get familiar with other aspects of the TextSpot system, such as:
                <ul class="list-disc list-inside">
                    <li>Importing contacts</li>
                    <li>List Management for easier marketing</li>
                    <li>Auto-Responders</li>
                    <li>Integrations with Zapier</li>
                </ul>
                <br />
            </div>
        </template>

        <template #footer>
            <a href='#' class="mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" 
                v-on:click="openIntercom" 
            >
                Contact Support
            </a>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'MessageHeldOnTrial',
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },
    methods: {
        openIntercom() {
            window.Intercom('showNewMessage');
        }
    },
    computed: {
    }

}
</script>